import { motion } from "framer-motion";
import { RotateCcw, Plus, Check } from "lucide-react";
import { useCart } from "../context/CartContext";

const euro = (n) => `€${n.toFixed(2).replace(".", ",")}`;

export const RecurringList = ({ recurringProducts }) => {
  const { addItem, items } = useCart();

  const addAll = () => recurringProducts.forEach((p) => addItem(p, 1));

  return (
    <section id="ricorrenti" className="mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-32">
      <div className="rounded-[2rem] border border-ink/10 bg-panel p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] md:p-14">
        <div className="mb-10 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div>
            <p className="mb-4 flex items-center gap-2 text-xs uppercase tracking-overline text-electric">
              <RotateCcw className="h-4 w-4" strokeWidth={1.6} /> Lista ricorrente
            </p>
            <h2 className="max-w-lg font-serif text-4xl font-light leading-tight text-ink md:text-5xl">
              Riacquista in un tap ciò che compri sempre
            </h2>
            <p className="mt-4 max-w-md text-sm text-ink-soft" data-testid="recurring-availability-note">
              Il riacquisto è valido se i prodotti sono disponibili al momento dell'ordine.
            </p>
          </div>
          <button
            onClick={addAll}
            data-testid="rebuy-all-button"
            className="self-start rounded-full bg-sage px-7 py-4 text-sm font-semibold text-cream transition-transform hover:scale-[1.04] active:scale-95"
          >
            Riacquista tutto
          </button>
        </div>

        <div className="divide-y divide-ink/10">
          {recurringProducts.map((p, i) => {
            const inCart = items.some((it) => it.id === p.id);
            return (
              <motion.div
                key={p.id}
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.04 }}
                className="flex items-center gap-4 py-4"
                data-testid={`recurring-item-${p.id}`}
              >
                <div className="clip-frame h-16 w-16 flex-shrink-0 overflow-hidden rounded-xl">
                  <img src={p.image} alt={p.name} className="h-full w-full object-contain bg-white p-2" />
                </div>
                <div className="min-w-0 flex-1">
                  <h4 className="truncate font-serif text-lg text-ink">{p.name}</h4>
                  <p className="text-sm text-ink-soft">{euro(p.price)}</p>
                </div>
                <button
                  onClick={() => addItem(p)}
                  data-testid={`rebuy-item-${p.id}`}
                  className={`flex items-center gap-2 rounded-full px-4 py-2.5 text-sm font-medium transition-all ${
                    inCart ? "bg-electric/15 text-electric" : "bg-ink text-cream hover:bg-sage"
                  }`}
                >
                  {inCart ? <Check className="h-4 w-4" strokeWidth={2} /> : <Plus className="h-4 w-4" strokeWidth={2} />}
                  <span className="hidden sm:inline">{inCart ? "Aggiunto" : "Riacquista"}</span>
                </button>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
